import React, { useEffect, useState } from 'react';
import { Snackbar, Alert, Button } from '@mui/material';

/**
 * Captures Chrome/Edge/Android's `beforeinstallprompt` event so we can offer
 * "ana ekrana ekle" at our own time. iOS Safari doesn't fire this event —
 * users there install via Share → Add to Home Screen (we surface a hint
 * elsewhere if needed).
 *
 * Suppresses re-prompts for 14 days after the user dismisses or installs,
 * via localStorage.
 */
const SUPPRESS_KEY = 'pwa-install-prompt-suppress';
const SUPPRESS_DAYS = 14;

function isSuppressed() {
  const t = Number(localStorage.getItem(SUPPRESS_KEY));
  return t && t > Date.now() - SUPPRESS_DAYS * 24 * 3600 * 1000;
}

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isSuppressed()) return;
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setOpen(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch (_) { /* */ }
    localStorage.setItem(SUPPRESS_KEY, String(Date.now()));
    setOpen(false);
    setDeferred(null);
  };

  const dismiss = () => {
    localStorage.setItem(SUPPRESS_KEY, String(Date.now()));
    setOpen(false);
  };

  if (!deferred) return null;

  return (
    <Snackbar
      open={open}
      onClose={dismiss}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity="info"
        onClose={dismiss}
        action={
          <Button color="inherit" size="small" onClick={install}>
            Ekle
          </Button>
        }
        sx={{ width: '100%' }}
      >
        Peak Portal'ı ana ekranına ekleyerek uygulama gibi kullanabilirsin.
      </Alert>
    </Snackbar>
  );
}
